import type { UUID } from '@/types/Id'

/** A playbook whose plays are picked: one the org saved, or one in the Sweetspot library. */
export type PlaybookRef = { promptId: UUID } | { librarySlug: string }

/** A playbook the org saved, by its id. */
export type SavedPlaybookRef = Extract<PlaybookRef, { promptId: UUID }>

/** Whether the playbook is one the org saved, rather than one in the library. */
export const isSavedPlaybook = (
  playbook: PlaybookRef,
): playbook is SavedPlaybookRef => 'promptId' in playbook

/** Plays picked on a playbook's map, by the playbook and their node ids. */
export type PlaysCitation = PlaybookRef & { nodeIds: string[] }

/** The playbook as a card's header names it: `playbook:<id>` or `library:<slug>`. */
export const playbookRefKey = (playbook: PlaybookRef) =>
  isSavedPlaybook(playbook)
    ? `playbook:${playbook.promptId}`
    : `library:${playbook.librarySlug}`

/** The plays as a card's header cites them: the playbook's key, then `#` and their node ids. */
export const playsCitationKey = (plays: PlaysCitation) =>
  `${playbookRefKey(plays)}#${plays.nodeIds.join(',')}`
